import styled from 'styled-components';

export const BarLabel = styled.text`
  font-size: 18px;
  font-weight: 500;
  font-family: Roboto;
  fill: rgb(51, 51, 51);
`;
